import { FiZap } from "react-icons/fi";

export default function NewProgramCard() {
  return (
    <div className="rounded-3xl border border-zinc-800 bg-[#111113] p-7">

      <div className="flex flex-col lg:flex-row gap-4">

        <div className="h-12 w-12 rounded-xl bg-red-600/20 flex items-center justify-center">

          <FiZap className="text-red-500" />

        </div>

        <div className="flex-1">

          <h3 className="text-xl font-semibold">
            Ein neues Staking-Programm ist in Arbeit
          </h3>

          <p className="text-zinc-400 mt-3 leading-7">
            Wir arbeiten an einem neuen Staking-Programm, das schnellstmöglich live gehen soll. Details, Konditionen und Zeitpunkt stehen noch nicht fest und werden zu gegebener Zeit ausschliesslich über die offiziellen BlackChain-Kanäle kommuniziert.
          </p>

          <span className="text-yellow-500 uppercase text-sm tracking-widest mt-6 inline-block">
            In Entwicklung
          </span>

        </div>

      </div>

    </div>
  );
}